import { IGreetingLayout } from 'types'
import { addLayoutTag } from '../../../utils/helpers'
import WelcomeUser from '../../WelcomeUser'

export default function GreetingLayout({}: Omit<IGreetingLayout, 'type'>) {
  return <WelcomeUser {...addLayoutTag('greeting')} />
}
